import {useGesture} from '@use-gesture/react'
import {Input, Modal, ModalProps} from 'semantic-ui-react'
import {secondsToTimeString, timeStringToSeconds} from '../../utils'
import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react'

export interface ICommandModalRef {
  open: () => void
}

export interface ICommandModalProps extends Omit<ModalProps, 'open' | 'onSeek'> {
  currentTime: number | undefined
  onSeek: (value: number) => void
}

export const CommandModal = forwardRef<ICommandModalRef, ICommandModalProps>((props, ref) => {
  {
    const {currentTime, onSeek, ...rest} = props

    const inputRef = useRef<Input>(null)

    const [isOpen, setIsOpen] = useState(false)

    useImperativeHandle(ref, () => {
      return {
        open: () => {
          setIsOpen(true)
        },
      }
    })

    useGesture(
      {
        onKeyDown: ({event}) => {
          const t = event.target as HTMLInputElement
          if (event.ctrlKey && event.code === 'KeyT') setIsOpen(true)
          else if (
            isOpen &&
            t.tagName === 'INPUT' &&
            t.parentElement?.classList.contains('ts-edit')
          ) {
            if (event.code === 'Enter') {
              event.stopPropagation()
              event.preventDefault()
              const s = timeStringToSeconds(t.value)
              if (s !== undefined) onSeek(s)
              setIsOpen(false)
            }
          }
        },
      },
      {
        target: window,
        eventOptions: {
          passive: false,
        },
      }
    )

    useEffect(() => {
      if (isOpen) inputRef.current?.select()
    }, [isOpen])

    return (
      <Modal
        open={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        {...rest}
      >
        <Modal.Content>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '0.5em',
            }}
          >
            <Input
              ref={inputRef}
              className='ts-edit'
              type='text'
              label='seek to:'
              defaultValue={secondsToTimeString(currentTime)}
            />
          </div>
        </Modal.Content>
      </Modal>
    )
  }
})
